export default __webpack_public_path__ + "static/affiliatepremises-3adb4ea2d275194fb57ecb85988edb46.png";